import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MessagesActions, MessagesActionsTypes } from './messages.actions';
import { Discussion, Discussions, MessagesContact } from './messages.models';

export const MESSAGES_STORE_KEY = 'messages';

interface MessagesState {
  contacts: Array<MessagesContact>;
  discussion: Discussion;
  discussions: Discussions;
  selectedDiscussionUuid: string;
}

export const messagesInitialState: MessagesState = {
  contacts: undefined,
  discussion: undefined,
  discussions: undefined,
  selectedDiscussionUuid: undefined
};

export function messagesReducer(
  state = messagesInitialState,
  action: MessagesActions
): MessagesState {
  switch (action.type) {
    case MessagesActionsTypes.LOAD_SELECTED_DISCUSSION:
      return { ...state, discussion: void 0 };

    case MessagesActionsTypes.LOAD_SELECTED_DISCUSSION_SUCCESS:
      return { ...state, discussion: action.payload };

    case MessagesActionsTypes.LOAD_DISCUSSIONS_SUCCESS:
      return { ...state, discussions: action.payload };

    case MessagesActionsTypes.LOAD_CONTACTS_SUCCESS:
      return { ...state, contacts: action.payload };

    case MessagesActionsTypes.SELECT_DISCUSSION:
      return { ...state, selectedDiscussionUuid: action.payload };

    case MessagesActionsTypes.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        discussion: {
          ...state.discussion,
          messages: [...state.discussion.messages, action.payload]
        }
      };

    default:
      return state;
  }
}

const messagesState = createFeatureSelector<MessagesState>(MESSAGES_STORE_KEY);

export const selectorMessagesContacts = createSelector(
  messagesState,
  state => state.contacts
);

export const selectorMessagesDiscussion = createSelector(
  messagesState,
  state => state.discussion
);

export const selectorMessagesDiscussions = createSelector(
  messagesState,
  state => state.discussions
);

export const selectorMessagesSelectedDiscussionUuid = createSelector(
  messagesState,
  state => state.selectedDiscussionUuid
);
